/** Display formatting. Everything arrives as integer pence or a numeric string. */

const gbp = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const gbp0 = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
})

const num = new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 })
const num3 = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 3,
  maximumFractionDigits: 3,
})

export function money(pence: number | string | null | undefined): string {
  if (pence === null || pence === undefined) return '—'
  return gbp.format(Number(pence) / 100)
}

/** Rounded to the pound — for headline figures where pennies are noise. */
export function moneyRound(pence: number | string | null | undefined): string {
  if (pence === null || pence === undefined) return '—'
  return gbp0.format(Number(pence) / 100)
}

export function volume(m3: number | string | null | undefined, dp = 0): string {
  if (m3 === null || m3 === undefined) return '—'
  const n = Number(m3)
  if (!Number.isFinite(n)) return '—'
  return dp === 3 ? num3.format(n) : num.format(n)
}

export function count(n: number | string | null | undefined): string {
  if (n === null || n === undefined) return '—'
  return num.format(Number(n))
}

export function percent(part: number, whole: number): string {
  if (whole === 0) return '—'
  return `${((part / whole) * 100).toFixed(1)}%`
}

/** YYYY-MM-DD -> "Mar 2026" */
export function periodLabel(period: string): string {
  const d = new Date(`${period.slice(0, 10)}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return period
  return d.toLocaleDateString('en-GB', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

export function dateLabel(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

export function dateTimeLabel(iso: string | null | undefined): string {
  if (iso === null || iso === undefined) return 'never'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function bytes(n: number | null): string {
  if (n === null) return '—'
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`
  return `${(n / 1024 / 1024).toFixed(1)} MB`
}
